import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import {Location} from '@angular/common';
import { SlugService } from 'src/services/slug.service';

@Component({
  selector: 'app-common-component',
  templateUrl: './common-component.component.html',
  styleUrls: ['./common-component.component.scss'],
})
export class CommonComponentComponent implements OnInit, OnChanges {
  @Input() image;
  @Input() title;
  @Input() description;
  @Input() pagename;
  @Input() created_at;
  @Input() is_html = false;;

  constructor(
      private location: Location,
      private dom: DomSanitizer,
      public slug:SlugService
  ) { }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(this.is_html){
      this.description = this.dom.bypassSecurityTrustHtml(this.description);
    }
  }

  ngOnInit() {}

  gotobackPage() {
    this.slug.goback();
  }

}
